<script lang="ts" setup>
	import { onMounted } from 'vue'
	import { RouterView } from 'vue-router'

	import NavbarTop from '@/components/navbars/NavbarTop.vue'
	import { useAuthStore, useCommonStore } from '@/stores'

	const authStore = useAuthStore()

	onMounted(async () => {
		await authStore.initialize()
		await authStore.getAllTokens()
		useCommonStore()
	})
</script>

<template>
	<!-- menu -->
	<!-- view -->
	<main id="top" class="main">
		<div class="container-fluid px-0" data-layout="container">
			<NavbarTop />
			<div class="content pt-md-3 pb-0 px-md-3">
				<RouterView v-slot="{ Component }">
					<!-- <Suspense>
						main content -->
					<component :is="Component"></component>

					<!-- loading state
						<template #fallback> Loading... </template>
					</Suspense> -->
				</RouterView>
			</div>
		</div>
	</main>

	<!-- error -->
	<div></div>
	<div v-if="authStore.error" id="error">{{ authStore.error }}</div>
</template>
